import React from 'react';
import { getWeatherIcon } from '../utils/uiService';

/**
 * CurrentWeather Component
 * Displays current weather conditions and details
 */
const CurrentWeather = ({ weather, unit, onUnitToggle }) => {
  if (!weather) {
    return (
      <div className="text-center text-gray-400 mt-20">
        <p className="text-xl">Enter a location to get weather information</p>
      </div>
    );
  }

  const displayTemp = unit === 'F' 
    ? Math.round((weather.temperature * 9/5) + 32)
    : weather.temperature;

  const displayFeelsLike = unit === 'F'
    ? Math.round((weather.feelsLike * 9/5) + 32)
    : weather.feelsLike;

  return (
    <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8">
      <div className="flex flex-col md:flex-row justify-between items-center gap-6">
        <div>
          <h1 className="text-4xl font-bold mb-2">{weather.location}</h1>
          <p className="text-xl text-gray-300 flex items-center gap-2">
            <span>{getWeatherIcon(weather.condition)}</span>
            {weather.condition}
          </p>
        </div>
        <div className="text-center">
          <div className="flex items-start gap-2">
            <div className="text-7xl font-bold">{displayTemp}°</div>
            <button
              onClick={onUnitToggle}
              className="mt-2 px-3 py-1 text-sm bg-white/10 rounded-lg hover:bg-white/20 transition-colors"
              aria-label={`Switch to ${unit === 'C' ? 'Fahrenheit' : 'Celsius'}`}
            >
              °{unit === 'C' ? 'F' : 'C'}
            </button>
          </div>
          <p className="text-gray-300">Feels like {displayFeelsLike}°</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
        <div className="text-center">
          <p className="text-gray-300">Humidity</p>
          <p className="text-2xl font-semibold">{weather.humidity}%</p>
        </div>
        <div className="text-center">
          <p className="text-gray-300">Wind Speed</p>
          <p className="text-2xl font-semibold">{weather.windSpeed} km/h</p>
          {weather.windDirection && (
            <p className="text-sm text-gray-400">{weather.windDirection}</p>
          )}
        </div>
        <div className="text-center">
          <p className="text-gray-300">Visibility</p>
          <p className="text-2xl font-semibold">{weather.visibility} km</p>
        </div>
        <div className="text-center">
          <p className="text-gray-300">UV Index</p>
          <p className="text-2xl font-semibold">{weather.uvIndex}</p>
        </div>
      </div>
    </div>
  );
};

export default CurrentWeather;
